import { withRouter } from '@atlassian/react-resource-router';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import type { State } from '../../../state/reducers/types.tsx';
import { getUseJSMQueueDurationEvent } from '../../../state/selectors/ui/index.tsx';
import { connect } from '../../../state/store/index.tsx';
import type { StateProps, OwnProps } from './types.tsx';
import SummaryField from './view.tsx';

const mapStateToProps = (state: State) => ({
	useJSMQueueDurationEvent: getUseJSMQueueDurationEvent(state),
});

const mergeProps = (stateProps: StateProps, dispatchProps: {}, ownProps: OwnProps) => ({
	...ownProps,
	...stateProps,
});

const SummaryConnected = connect(mapStateToProps, {}, mergeProps)(SummaryField);

export default componentWithFG(
	'use_queues_url_for_issue_link_on_jsm_queues',
	withRouter(SummaryConnected),
	SummaryConnected,
);
